export const commonFormStylesIdentifier = 'g-CommonFormStyles';
export const commonPageStylesIdentifier = 'g-CommonPageStyles';
export const CommonPageStylesDesktopBackButton =
  'g-CommonPageStyles__desktopBackButton';
